import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTankDishedRoofConicalBottom = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 125.46,
	viewBox: "0 0 100.0 125.46",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 95.46 L 0.0 25.46 A 75.0 75.0 0.0 0 1 100.0 25.46 L 100.0 95.46 L 50.0 125.46 Z M 0.0 25.46 L 100.0 25.46 M 0.0 95.46 L 100.0 95.46",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgTankDishedRoofConicalBottom;
